import api from "../services/api"

const getAllGoogleAdAccounts = async () => {
    try {
        const response = await api.get("/integrations/google/adAccounts")
        return response.data?.data || []
    } catch (err) {
        console.log(err?.response?.data?.message)
        return []
    }
}

export { getAllGoogleAdAccounts }
